import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormGroupControl } from '@components/Base';
import { selectIsHospital } from '@components/Auth';

const GROUP_PROPS = { className: 'mb-3' };

const ContactInfoCardBody = () => {
  const { t } = useTranslation();
  const isHospital = useSelector(selectIsHospital);

  return (
    <Card.Body>
      <Card.Title>{t('healthInsuranceClaimForm.contactInfoSection.title')}</Card.Title>
      <Row>
        <Col>
          <FormGroupControl
            required
            name="mobileNumber"
            label={t('user.mobileNumber')}
            groupProps={GROUP_PROPS}
            disabled={isHospital}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            name="email"
            label={t('user.email')}
            groupProps={GROUP_PROPS}
            disabled={isHospital}
          />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ContactInfoCardBody };
